import { Package } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

// Footer Component
export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="py-6 px-6 md:px-12 border-t" style={{ borderColor: '#DAD7CD' }}>
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-body text-sm" style={{ color: '#6B705C' }}>
          {t.developedWith}
        </p>
        <a
          href="https://www.floralife.mx/productos-para-flores"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 font-body text-sm hover:underline"
          style={{ color: '#A3B18A' }}
        >
          <Package className="w-4 h-4" />
          {t.knowAllProducts}
        </a>
      </div>
    </footer>
  );
};
